export default __webpack_public_path__ + "static/media/close.b9e96553.svg";